var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Inventario por caja","sub-title":"Ingreso de seriales por caja"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('inventory-by-box-card',{attrs:{"stowage-id":_vm.stowageId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }